import React from 'react'
import burgerLogo from '../../assets/images/burgerlogo.png'
import './logo.css'
const logo = (props) => ( 
    <div className='Logo'>
    <img src={ burgerLogo } alt="" />
</div>
)
export default logo